import { useSelector } from "react-redux";
import classNames from "classnames";

import { ApplePayButton, PaymentSystem } from "@web-solutions/react-billing";
import { ApplePayTruegateContainer } from "@web-solutions/react-billing/truegate/ApplePayContainer";
import { selectPaymentSystem } from "@web-solutions/core/store/billing/selectors";
import { STRIPE_INTRO_PAYMENT } from "@web-solutions/core/utils/stripe-payment";
import { APP_NAME } from "@web-solutions/core/constants/general";

import classes from "./style.module.scss";
import "./style.scss";
import { useRemoteConfig } from "core/hooks/use-remote-config";

const ApplePay = ({
  options,
  activeProduct,
  className,
  onApplePayClick,
  onApplePaySubmit,
  onApplePayReady,
  onApplePaySuccess,
  onApplePayError,
}) => {
  const email = useSelector((state) => state.profile.email);
  const paymentSystem = useSelector(selectPaymentSystem);
  const { flow, collectEmailAfterPayment } = useRemoteConfig();

  // Stripe deferred-email flow: an anonymous Stripe customer (with a billing
  // token) is created on the paywall, so Apple Pay can charge without an email —
  // it is collected afterwards on the email-after-payment page. Don't disable
  // the button on a missing email in that case.
  const emailOptional =
    collectEmailAfterPayment && paymentSystem === PaymentSystem.STRIPE;

  // Stripe subscription products don't carry flat `amount`/`currency`/
  // `trial_price_amount`, but ApplePayButton/useApplePay need them (without a
  // currency the paymentRequest is never created and the button stays hidden).
  // Today's actual charge is the intro one-time payment ($0.99), so surface that.
  const isStripe = paymentSystem === PaymentSystem.STRIPE;
  const productForApplePay = isStripe
    ? {
        ...activeProduct,
        isIntroductory: true,
        amount: Number(activeProduct?.amount) || STRIPE_INTRO_PAYMENT.amount,
        trial_price_amount:
          Number(activeProduct?.trial_price_amount) || STRIPE_INTRO_PAYMENT.amount,
        currency: activeProduct?.currency || STRIPE_INTRO_PAYMENT.currency,
      }
    : activeProduct;

  const handleSubmit = (formData) => {
    onApplePaySubmit({ email, ...formData });
  };

  if (paymentSystem === PaymentSystem.TRUEGATE) {
    return (
      <ApplePayTruegateContainer
        product={activeProduct}
        options={options}
        email={email}
        className={className}
        onReady={onApplePayReady}
        onClick={onApplePayClick}
        onSubmit={handleSubmit}
        onSuccess={onApplePaySuccess}
        onError={onApplePayError}
      />
    );
  }

  return (paymentSystem !== PaymentSystem.SOLIDGATE &&
    paymentSystem !== PaymentSystem.PADDLE) ||
    !!process.env.REACT_APP_APPLE_PAY_H2H ? (
    <ApplePayButton
      product={productForApplePay}
      label={APP_NAME}
      disabled={!email && !emailOptional}
      className={classNames(classes.btn, className)}
      onClick={onApplePayClick}
      onSubmit={handleSubmit}
      onReady={onApplePayReady}
      // requireEmail={!flow.includes('EMAIL')}
    />
  ) : null;
};

export default ApplePay;
